<template>
  <div class="modalback">
    <div class="modalcontent container" @click="closeAction">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <div class="row justify-content-center align-items-center" style="min-height: 90px;">
          <div class="col" style="white-space: break-spaces;">
            <p style="font-size: 20px; white-space: pre-wrap;font-weight:700;">再注文しますか？</p>
          </div>
      </div>
      <div class="row justify-content-center pt-5" style="">
          <div class="col-auto d-flex flex-row justify-content-between" style="width: 550px">
              <button class="acry-btn-secondary-normal btn-size" @click="addCartEditAction">編集してからカートに追加</button>
              <button class="acry-btn-primary-normal btn-size" @click="addCartSameDataAction">同じ内容をカートに追加</button>
          </div>
      </div>
    </div>
  </div>
  <!-- <div class="modalback" @click="closeAction">
    <div class="modalcontent container rounded-2 position-relative" v-on:click.stop="">
      <div class="row justify-content-center align-items-center">
          <p class="mt-5" style="font-size:20px;font-weight:700">再注文しますか？</p>
      </div>
      <div class="row justify-content-center align-items-end mt-5 pt-3" style="height: 60px">
        <div class="col">
          <button class="acryborderbtn me-5" @click="addCartEditAction">編集してからカートに追加</button>
          <button class="acrybtn" @click="addCartSameDataAction">同じ内容をカートに追加</button>
        </div>
      </div>
      <button style="
      position: absolute;
                top: 0px;
                left: 0px;
                right: 50px;
                z-index: 100; 
                background-color:transparent;
                border:0px;     
      "><img src="@/assets/acrypro/close.svg"></button>
    </div>
  </div> -->
</template>
<script>
export default {
  name: "ReOrderDesign_Ap",
  props: {},
  data: function () {
    return {
      selectDesignNum:1
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  methods: {
    async addCartSameDataAction() {
      await this.$store.state.reorderDesignCallback();
      this.$store.commit("setReorderDesign",false);
    },
    async addCartEditAction() {
      await this.$store.state.reeditDesignCallback();
      this.$store.commit("setReorderDesign",false);
    },
    closeAction() {
      this.$store.commit("setReorderDesign",false);
    },
  },
  components: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 800px;
  /* height: 200px; */
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}
.btn-size{
  width: 240px;
  height: 56px;
}
</style>
